module.exports = __webpack_public_path__ + "img/selected3-min.fdd0e84e.png";